import ShareIcon from './ShareIcon';

function Move ({ i, last, n, first_pos, last_pos, guess, reply, seq, rep, vsize, invalid, _show_invalids, is_complete, sharing, onShare, line_over_first, clue, clue_shown, clue_requested, word_rank, word_count, mm_actual, mm_best, mm_worst, vocab_actual, vocab_best, vocab_worst, gameAvgScore, gameMmScore, allGamesAvg, allGamesMmAvg, gameMaxScore, allGamesMaxAvg }) {
  const copy_button = (
    <button key='copy' className="copy" onClick={() => onShare(i)}>
      <ShareIcon />
    </button>
  );
  const seq_div = <div className="seq">{(clue_requested ? "*" : (clue_shown ? "~" : "")) + ((clue_requested || clue_shown) && seq === "." ? "" : (rep === 1 ? seq : ""))}</div>
  const rep_div = <div className="rep">{rep}</div>
  const vsize_div = allGamesMaxAvg != null ? <div className="vsize" style={{ left: 0, right: 'auto' }}>{allGamesMaxAvg.toFixed(2)}</div> : (vsize > -1 ? <div className="vsize">{vsize}+</div> : null);
  const mm_vsize_div = allGamesMmAvg != null ? <div className="vsize" style={{ left: 'auto', right: 0, display: 'none' }}>{allGamesMmAvg.toFixed(2)}</div> : null;
  const is_correct = reply === "G".repeat(n);
  const has_rank_data = (vocab_actual || 0) > 0 || (word_rank > 0 && word_count > 0);
  const has_mm_data = mm_best > 0;
  const move_score = (vocab_actual || 0) > 0
    ? (vocab_best === vocab_worst ? 4 : 4.0 * (Math.log(vocab_best) - Math.log(vocab_actual)) / (Math.log(vocab_best) - Math.log(vocab_worst)))
    : (has_rank_data ? (4 * word_rank / word_count) : 0);
  const move_mm_score = !has_mm_data ? 0 : mm_best === mm_worst ? 4 : (4.0 * (Math.log(mm_worst) - Math.log(mm_actual)) / (Math.log(mm_worst) - Math.log(mm_best)));
  const scoreToGrade = (s) => s < 1 ? 'D' : s < 2 ? 'C' : s < 3 ? 'B' : 'A';
  const move_grade_val = (has_rank_data || is_correct) ? (is_correct ? 'A' : scoreToGrade(move_score)) : '';
  const move_mm_grade_val = (has_mm_data || is_correct) ? (is_correct ? 'A' : scoreToGrade(move_mm_score)) : '';
  
  let vocabWeight = 'normal';
  let mmWeight = 'normal';
  let vocabOpacity = 0.8;
  let mmOpacity = 0.8;
  let vocabDecoration = 'none';
  let mmDecoration = 'none';
  
  if (move_score > move_mm_score) {
    vocabWeight = 'bold';
    vocabOpacity = 1;
    vocabDecoration = 'underline';
  } else if (move_mm_score > move_score) {
    mmWeight = 'bold';
    mmOpacity = 1;
    mmDecoration = 'underline';
  } else {
    vocabWeight = 'bold';
    mmWeight = 'bold';
    vocabOpacity = 1;
    mmOpacity = 1;
    vocabDecoration = 'underline';
    mmDecoration = 'underline';
  }

  const move_combined_grade_div = (move_grade_val || move_mm_grade_val) ? (
    <div className="frac_rank" style={{ left: 'auto', right: 0, padding: '1px' }}>
      {move_grade_val && <span style={{ fontWeight: vocabWeight, opacity: vocabOpacity, textDecoration: vocabDecoration }}>{move_grade_val}</span>}
      {move_mm_grade_val && <span style={{ fontWeight: mmWeight, opacity: mmOpacity, textDecoration: mmDecoration }}>{move_mm_grade_val}</span>}
    </div>
  ) : null;
  const avg_score_div = gameMaxScore != null ? <div className="frac_rank" style={{ left: 0, right: 'auto' }}>{gameMaxScore.toFixed(2)}</div> : null;
  const avg_mm_score_div = gameMmScore != null ? <div className="frac_rank" style={{ left: 'auto', right: 0, display: 'none' }}>{gameMmScore.toFixed(2)}</div> : null;
  return (
    <div className={"a" + (i === 0 && line_over_first ? " first" : "")} style={{ gridTemplateColumns: `repeat(${guess.length}, 1fr)` }}>
      {invalid ? <button key="close" className="close" onClick={() => _show_invalids(false)}>-</button> : <></>}
      {[...[...guess].keys()].map(j =>
        <div key={j} className={"b " + (n > 7 ? "shrink " : "") + reply[j]}>
          {guess[j]}
          {j === last_pos && is_complete() && ! sharing && (seq === "." || seq > 0) ? seq_div : null}
          {!last && j === first_pos && is_complete() && ! sharing && rep > 1 ? rep_div : null}
          {last && j === first_pos && is_complete() && ! sharing && vsize_div != null ? vsize_div : null}
          {last && j === first_pos && is_complete() && ! sharing && mm_vsize_div != null ? mm_vsize_div : null}
          {j === last_pos && is_complete() && ! sharing && ! invalid && (has_rank_data || has_mm_data || is_correct) ? move_combined_grade_div : null}
          {last && j === first_pos && is_complete() && ! sharing && ! invalid && gameMaxScore != null ? avg_score_div : null}
          {last && j === first_pos && is_complete() && ! sharing && ! invalid && gameMmScore != null ? avg_mm_score_div : null}
        </div>
      )}
      {(last && is_complete() && gameAvgScore != null) ? (
        <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'space-between', padding: '2px 0 0 0', fontSize: '9px', color: '#888', whiteSpace: 'nowrap' }}>
          <span style={{textAlign: 'left', display: 'flex', alignItems: 'baseline', gap: '3px'}}>
            <span>{allGamesAvg?.toFixed(2)}</span>
            <span style={{fontSize: '7.5px'}}>{gameAvgScore?.toFixed(2)}</span>
          </span>
          <span style={{textAlign: 'right', display: 'flex', alignItems: 'baseline', gap: '3px'}}>
            <span style={{fontSize: '7.5px'}}>{gameMmScore?.toFixed(2)}</span>
            <span>{allGamesMmAvg?.toFixed(2)}</span>
          </span>
        </div>
      ) : null}
      {sharing ? copy_button : null}
    </div>
  );
}

export default Move;

